import types from './actionTypes';

const initialState = {
    pending: {
        list: false,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.VENUES_REQUEST: {
            return {
                pending: {
                    list: true,
                },
            };
        }
        case types.VENUES_REQUEST_COMPLETED: {
            return {
                pending: {
                    list: false,
                },
            };
        }
        default:
            return state;
    }
};
